import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  dialog: {
    width: "90vw",
    "@media (min-width: 500px)": {
      marginTop: "230px",
    },
  },
  dialogWithoutMarginTop: {
    width: "90vw",
  },
  dialogActions: {
    display: "flex",
    "@media (orientation: portrait)": { flexDirection: "column" },
    "@media (orientation: landscape)": { flexDirection: "row" },
    justifyContent: "space-evenly",
    ...shorthands.gap("12px"),
  },
  dialogButton: {
    height: "40px",
  },
});
